module.exports = __webpack_public_path__ + "img/ice-mountain-close.959e9445.svg";